import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import TransferListings from "../../components/pt-transfer/TransferListings";
import { selectUser } from "../../components/auth/auth.selector";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import { fetchTransferedPTData } from "../../redux/dashboard-features/featuresSlice";
import PTTransferForm from "../../components/pt-transfer/PTTransferForm";
import "../../styles/pt/pt-transfer.css";

const PTTransfer = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const { transferedPTLoading } = useSelector((state) => state.features);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: "",
    selectedTrainer: "",
    isActive: "",
    selectedTransferFrom: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    subscription_status: allFilters.isActive?.value || "",
    transferred_from: allFilters.selectedTransferFrom?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getPTTransferList(filters) {
    dispatch(
      fetchTransferedPTData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getPTTransferList(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      subscription_status: allFilters.isActive?.value || "",
      transferred_from: allFilters.selectedTransferFrom?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedTrainer,
    allFilters.isActive,
    allFilters.selectedTransferFrom,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: PT Transfer">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          <div className={`createNewCTOModalContainer`}>
            <PTTransferForm
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              callFunction={() => getPTTransferList(filters)}
            />
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"PT Transfer"}
              createBtnTxt={"Fetch New Member"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
              isReload={() => getPTTransferList(filters)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CmnFilters
              from={"pt-transfer"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={transferedPTLoading}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TransferListings
              userInfoData={userInfoData}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default PTTransfer;
